var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-input-number',{attrs:{"size":"mini","min":_vm.min,"max":_vm.max},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}}),_c('span',{staticStyle:{"margin-left":"6px","color":"#a2b1cb","font-size":"12px"}},[_vm._v("("+_vm._s(_vm.unit)+")")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }